export default class FlowManager {
    private readonly ENTER_KEY = 'Enter';

    constructor(
        private canContinue: () => boolean, 
        private onContinue: () => void
    ) {
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.tryToContinue = this.tryToContinue.bind(this);
        this.registerListeners = this.registerListeners.bind(this);
        this.unregisterListeners = this.unregisterListeners.bind(this);
    }

    public unregisterListeners(): void {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    public registerListeners(): void {
        document.addEventListener('keydown', this.handleKeyDown);
    }

    public tryToContinue(): void {
        if (this.canContinue()) {
            this.onContinue();
        }
    }

    private handleKeyDown(event: any): void {
        if (event.key === this.ENTER_KEY) {
            event.preventDefault();
            this.tryToContinue();
        }
    }
}


// WEBPACK FOOTER //
// ./src/webportal/components/common/FlowManager.ts